module.exports = __webpack_public_path__ + "static/media/webview-products.eca76164.png";